import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../lib/i18next";
import {
  GOOGLE,
  GOOGLE_DRIVE,
  META,
  TIKTOK,
  YOUTUBE,
  LINKEDIN,
} from "../../utils/constants";
import connectionGoogleGif from "../../assets/img/connection_google.gif";
import connectionGoogleGifEn from "../../assets/img/connection_google_en.gif";
import connectionTiktokGif from "../../assets/img/connection_tiktok.gif";
import connectionTiktokGifEn from "../../assets/img/connection_tiktok_en.gif";
import connectionMetaGif from "../../assets/img/connection_meta.gif";
import connectionMetaGifEn from "../../assets/img/connection_meta_en.gif";
import connectionYouTubeGif from "../../assets/img/connection_youtube_es.gif";
import connectionYouTubeGifEn from "../../assets/img/connection_youtube_en.gif";
import {
  CONNECTING_TO_PLATFORM,
  CONNECTING_TO_PLATFORM_DESCRIPTION,
} from "../../i18n/keysTranslations";
import { getLanguageFormatted } from "../../utils/string";

const ConnectionProgressModal = ({ platform = GOOGLE, title }) => {
  const { t, i18n } = useTranslationApp();

  const getGifByPlatform = () => {
    switch (platform.toLowerCase()) {
      case GOOGLE.toLowerCase():
        return getLanguageFormatted(i18n.language) === "en"
          ? connectionGoogleGifEn
          : connectionGoogleGif;
      case GOOGLE_DRIVE.toLowerCase():
        return "";
      case YOUTUBE.toLowerCase():
        return getLanguageFormatted(i18n.language) === "en"
          ? connectionYouTubeGifEn
          : connectionYouTubeGif;
      case TIKTOK.toLowerCase():
        return getLanguageFormatted(i18n.language) === "en"
          ? connectionTiktokGifEn
          : connectionTiktokGif;
      case META.toLowerCase():
      case "facebook":
        return getLanguageFormatted(i18n.language) === "en"
          ? connectionMetaGifEn
          : connectionMetaGif;
      case LINKEDIN.toLowerCase():
        return "";
      default:
        return getLanguageFormatted(i18n.language) === "en"
          ? connectionGoogleGifEn
          : connectionGoogleGif;
    }
  };

  const getPlatformDisplayName = () => {
    switch (platform.toLowerCase()) {
      case GOOGLE.toLowerCase():
        return "Google";
      case GOOGLE_DRIVE.toLowerCase():
        return "Google Drive";
      case YOUTUBE.toLowerCase():
        return "YouTube";
      case META.toLowerCase():
      case "facebook":
        return "Meta";
      case LINKEDIN.toLowerCase():
        return "LinkedIn";
      default:
        return platform.charAt(0).toUpperCase() + platform.slice(1);
    }
  };

  const getDefaultTitle = () => {
    if (title) return title;
    return t(CONNECTING_TO_PLATFORM, { platform: getPlatformDisplayName() });
  };

  const getDefaultDescription = () => {
    return t(CONNECTING_TO_PLATFORM_DESCRIPTION, {
      platform: getPlatformDisplayName(),
    });
  };

  const gif = getGifByPlatform();
  const hasGif = Boolean(gif);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        p: { xs: 1, sm: 2, md: 3 },
        width: "100%",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          textAlign: "center",
        }}
      >
        {getDefaultTitle()}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          textAlign: "center",
        }}
      >
        {getDefaultDescription()}
      </Typography>
      {hasGif && (
        <Box
          component="img"
          src={gif}
          alt={`Connecting to ${getPlatformDisplayName()}`}
          sx={{
            width: "auto",
            maxHeight: `calc(85vh - 220px)`,
            objectFit: "cover",
            maxWidth: "80vw",
            borderRadius: 2,
          }}
        />
      )}
    </Box>
  );
};

export default ConnectionProgressModal;
